// Совет акционеров (deus_sovet_aktsionerov, legendary) — order при размещении.
// Сбрасывает 3 карты из руки, берёт 3 карты, +2 extraPlaysNextTurn.
//
// API: opts.discardInstanceIds — массив id карт для сброса (выбор Игрока).
// Если меньше 3 — сбрасываем что есть. Если null/пустой — пропускаем сброс
// (но эффект «взять 3» всё равно срабатывает, и +2 extraPlays).

export const CARD_ID = 'deus_sovet_aktsionerov';

export function sovetOrder(state, ownerIdx, opts = {}) {
  const p = state.players[ownerIdx];
  // Сброс выбранных.
  const ids = opts.discardInstanceIds || [];
  let discarded = 0;
  for (const id of ids.slice(0, 3)) {
    const idx = p.hand.findIndex(c => c.instanceId === id);
    if (idx === -1) continue;
    const c = p.hand.splice(idx, 1)[0];
    p.discard.push(c);
    discarded++;
  }
  if (discarded > 0) {
    state.log.add(`🏛 Совет акционеров [${p.name}]: сброшено ${discarded} карт`);
  } else {
    state.log.add(`🏛 Совет акционеров [${p.name}]: ничего не сброшено (выбор не сделан)`);
  }
  // +3 карты из колоды.
  let drawn = 0;
  for (let i = 0; i < 3; i++) {
    const c = p.drawOne();
    if (!c) break;
    if (p.hand.length >= 10) {
      p.discard.push(c);
      state.log.add(`🏛 Совет [${p.name}]: рука полна, "${c.name_ru}" сгорает`);
    } else {
      p.hand.push(c);
      drawn++;
    }
  }
  state.log.add(`🏛 Совет акционеров [${p.name}]: +${drawn} карты в руку`);
  // +2 extraPlaysNextTurn.
  p.extraPlaysNextTurn = (p.extraPlaysNextTurn || 0) + 2;
  state.log.add(`🏛 Совет акционеров [${p.name}]: +2 размещения в следующий Ф2`);
}
